// Dynamic Loading Modules

// public routes
export const publicRoutes = [
    '/auth/login',
];

// Views
const Dashboard = resolve => {
    require.ensure(['../views/Dashboard.vue'], () => {
        resolve(require('../views/Dashboard.vue'));
    });
};

// UI Components
const Buttons = resolve => {
    require.ensure(['../components/Buttons.vue'], () => {
        resolve(require('../components/Buttons.vue'));
    });
};
const Socials = resolve => {
    require.ensure(['../components/Socials.vue'], () => {
        resolve(require('../components/Socials.vue'));
    });
};
const Badges = resolve => {
    require.ensure(['../components/Badges.vue'], () => {
        resolve(require('../components/Badges.vue'));
    });
};
const Tabs = resolve => {
    require.ensure(['../components/Tabs.vue'], () => {
        resolve(require('../components/Tabs.vue'));
    });
};
const Cards = resolve => {
    require.ensure(['../components/Cards.vue'], () => {
        resolve(require('../components/Cards.vue'));
    });
};
const Modals = resolve => {
    require.ensure(['../components/Modals.vue'], () => {
        resolve(require('../components/Modals.vue'));
    });
};
const Alerts = resolve => {
    require.ensure(['../components/Alerts.vue'], () => {
        resolve(require('../components/Alerts.vue'));
    });
};
const ProgressBars = resolve => {
    require.ensure(['../components/ProgressBars.vue'], () => {
        resolve(require('../components/ProgressBars.vue'));
    });
};
const Switches = resolve => {
    require.ensure(['../components/switch/Switches.vue'], () => {
        resolve(require('../components/switch/Switches.vue'));
    });
};

const BasicForms = resolve => {
    require.ensure(['../components/forms/BasicForms.vue'], () => {
        resolve(require('../components/forms/BasicForms.vue'));
    });
};
const AdvancedForms = resolve => {
    require.ensure(['../components/forms/AdvancedForms.vue'], () => {
        resolve(require('../components/forms/AdvancedForms.vue'));
    });
};
const FormWizard = resolve => {
    require.ensure(['../components/forms/FormWizard.vue'], () => {
        resolve(require('../components/forms/FormWizard.vue'));
    });
};
const Grids = resolve => {
    require.ensure(['../components/Grids.vue'], () => {
        resolve(require('../components/Grids.vue'));
    });
};
const Widgets = resolve => {
    require.ensure(['../components/Widgets.vue'], () => {
        resolve(require('../components/Widgets.vue'));
    });
};
const Typography = resolve => {
    require.ensure(['../components/Typography.vue'], () => {
        resolve(require('../components/Typography.vue'));
    });
};
const Icons = resolve => {
    require.ensure(['../components/icons/Icons.vue'], () => {
        resolve(require('../components/icons/Icons.vue'));
    });
};
const SetsList = resolve => {
    require.ensure(['../components/icons/SetsList.vue'], () => {
        resolve(require('../components/icons/SetsList.vue'));
    });
};
const Sets = resolve => {
    require.ensure(['../components/icons/Set.vue'], () => {
        resolve(require('../components/icons/Set.vue'));
    });
};
const Tables = resolve => {
    require.ensure(['../components/tables/Tables.vue'], () => {
        resolve(require('../components/tables/Tables.vue'));
    });
};
// Charts
const ChartJS = resolve => {
    require.ensure(['../components/charts/ChartJS.vue'], () => {
        resolve(require('../components/charts/ChartJS.vue'));
    });
};
const FlotChart = resolve => {
    require.ensure(['../components/charts/FlotChart.vue'], () => {
        resolve(require('../components/charts/FlotChart.vue'));
    });
};
const PeityChart = resolve => {
    require.ensure(['../components/charts/PeityChart.vue'], () => {
        resolve(require('../components/charts/PeityChart.vue'));
    });
};
// Maps
const GoogleMapsPage = resolve => {
    require.ensure(['../components/maps/google-maps/GoogleMapsPage.vue'], () => {
        resolve(require('../components/maps/google-maps/GoogleMapsPage.vue'));
    });
};
const LeafletMapsPage = resolve => {
    require.ensure(['../components/maps/leaflet-maps/LeafletMapsPage.vue'], () => {
        resolve(require('../components/maps/leaflet-maps/LeafletMapsPage.vue'));
    });
};
const BubbleMapsPage = resolve => {
    require.ensure(['../components/maps/bubble-maps/BubbleMapsPage.vue'], () => {
        resolve(require('../components/maps/bubble-maps/BubbleMapsPage.vue'));
    });
};
const LineMapsPage = resolve => {
    require.ensure(['../components/maps/line-maps/LineMapsPage.vue'], () => {
        resolve(require('../components/maps/line-maps/LineMapsPage.vue'));
    });
};
// // User Info
// const User = resolve => { require.ensure(['../layouts/User.vue'], ()=>{ resolve(require('../layouts/User.vue')); }); };

//Pages
//return this.$route.path.match('auth')
const Login = resolve => {
    require.ensure(['../pages/login/Login.vue'], () => {
        resolve(require('../pages/login/Login.vue'));
    });
};
const Register = resolve => {
    require.ensure(['../pages/register/Register.vue'], () => {
        resolve(require('../pages/register/Register.vue'));
    });
};
const Page404 = resolve => {
    require.ensure(['../pages/Page404.vue'], () => {
        resolve(require('../pages/Page404.vue'));
    });
};
const Page500 = resolve => {
    require.ensure(['../pages/Page500.vue'], () => {
        resolve(require('../pages/Page500.vue'));
    });
};

export const routes = [{
        path: '',
        name: 'home',
        components: {
            default: Dashboard
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        components: {
            default: Dashboard
        }
    },
    {
        path: '/components/auth',
        name: 'auth',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
                path: '/auth/login',
                component: Login,
                name: 'login',
                meta: {
                    default: false,
                    title: 'Login'
                }
            },
            {
                path: '/auth/register',
                component: Register,
                name: 'Register'
            },
            {
                path: '/auth/Page404',
                component: Page404,
                name: 'Page404'
            },
            {
                path: '/auth/Page500',
                component: Page500,
                name: 'Page500'
            },

        ]
    },
    // user defined rules

    {
        path: '/companies',
        name: 'companies',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
                path: '/',
                name: 'companies',
                component: require("@/views/company/Company.vue").default,
            },
            {
                path: '/company/edit/',
                name: 'editcompany',
                prop: true,
                component: require("@/views/manual-forms/company-edit.vue").default
            },
        ],
        props: (route) => ({ query: route.query.page })
    },
    // {
    //     path: '/mutual-funds',
    //     name: 'mutualfunds',
    //     component: require("@/views/mutual-funds/rawdata.vue").default
    // },
    // {
    //     path: '/schemeholdings/:id',
    //     name: 'schemeholdings',
    //     component: require("@/views/mutual-funds/holdings.vue").default
    // },
    // {
    //     path: '/schemeratios/:id',
    //     name: 'schemeratios',
    //     component: require("@/views/mutual-funds/scheme-ratios.vue").default
    // },
    // {
    //     path: '/schemeprofileexpratios/:id',
    //     name: 'schemeprofileexpratios',
    //     component: require("@/views/mutual-funds/scheme-profile-exp-ratios.vue").default
    // },
    // {
    //     path: '/analysis/:id',
    //     name: 'mfanalysis',
    //     component: require("@/views/mutual-funds/analysis.vue").default
    // },
    // {
    //     path: '/analysis-sum/:id?',
    //     name: 'mfanalysissum',
    //     component: require("@/views/mutual-funds/analysis-sum.vue").default
    // },
    {
        path: '/mutual-funds',
        name: 'Mutual Funds',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
                path: 'rawdata',
                name: 'mutualfundsRawdata',
                component: require("@/views/mutual-funds/rawdata.vue").default
            },
            {
                path: 'schemes/:id?',
                name: 'mutualfundsSchemes',
                component: require("@/views/mutual-funds/scheme-master.vue").default
            },
            {
                path: 'p-trends',
                name: 'pTrends',
                component: require("@/views/mutual-funds/pTrends.vue").default
            },
            {
                path: 'schemeholdings/:id',
                name: 'schemeholdings',
                component: require("@/views/mutual-funds/holdings.vue").default
            },
            {
                path: 'schemeratios/:id',
                name: 'schemeratios',
                component: require("@/views/mutual-funds/scheme-ratios.vue").default
            },
            {
                path: 'schemeprofileexpratios/:id',
                name: 'schemeprofileexpratios',
                component: require("@/views/mutual-funds/scheme-profile-exp-ratios.vue").default
            },
            {
                path: 'analysis/:id',
                name: 'mfanalysis',
                component: require("@/views/mutual-funds/analysis.vue").default
            },
            {
                path: 'analysis-sum/:id?',
                name: 'mfanalysissum',
                component: require("@/views/mutual-funds/analysis-sum.vue").default
            },
            {
                path: 'all-scheme-analysis',
                name: 'mfallschemeanalysis',
                component: require("@/views/mutual-funds/all-scheme-analysis.vue").default
            },
            {
                path: 'fund-manager/:id?',
                name: 'fundmanager',
                component: require("@/views/mutual-funds/fund-manager.vue").default
            },
            {
                path: 'edit-debt/:type',
                name: 'editDebtRatings',
                component: require("@/views/mutual-funds/debt-ratings.vue").default
            },
            {
                path: 'edit-mf-form/:type',
                name: 'editMfForm',
                component: require("@/views/mutual-funds/multiplier-form.vue").default
            },
            {
                path: 'edit-mf-rating-form/:type',
                name: 'editMfRatingForm',
                component: require("@/views/mutual-funds/ratings-form.vue").default
            },
            {
                path: 'qualitative-statements',
                name: 'qualitativeStatements',
                component: require("@/views/mutual-funds/qualitative-statements.vue").default
            },
            {
                path: 'portfolio',
                name: 'mutualfundsPortfolio',
                component: require("@/views/mutual-funds/portfolio.vue").default
            },
            {
                path: 'scheme',
                name: 'mutualfundsScheme',
                component: require("@/views/mutual-funds/scheme.vue").default
            },
            {
                path: 'themes',
                name: 'themeScheme',
                component: require("@/views/mutual-funds/themes/scheme/scheme.vue").default
            },
            {
                path: 'themes/add',
                name: 'themeSchemeAdd',
                component: require("@/views/mutual-funds/themes/scheme/add-edit-scheme.vue").default
            },
            {
                path: 'themes/edit/:id',
                name: 'themeSchemeEdit',
                component: require("@/views/mutual-funds/themes/scheme/add-edit-scheme.vue").default
            },
            {
                path: 'mf-portfolio',
                name: 'mfPortfolioListing',
                component: require("@/views/mutual-funds/portfolios/listing.vue").default
            },
            {
                path: 'mf-portfolio/add',
                name: 'mfPortfolioAdd',
                component: require("@/views/mutual-funds/portfolios/add-portfolios.vue").default,
                props: true
            },
            {
                path: 'mf-portfolios/details/:id/:name?',
                component: require("@/views/mutual-funds/portfolios/portfolio-details.vue").default,
                name: 'mfportfolio-details',
                props: true
            }, {
                path: 'mf-portfolios/reports/:id/:name?',
                component: require("@/views/mutual-funds/portfolios/portfolio-test-reports.vue").default,
                name: 'mfportfolio-test-reports',
                props: true
            }, {
                path: 'mf-portfolios/edit-scheme/:id/:sid',
                component: require("@/views/mutual-funds/portfolios/add-scheme.vue").default,
                name: 'mfedit-scheme',
                props: true
            }, {
                path: 'acl/users',
                component: require("@/views/mutual-funds/acl/users.vue").default,
                name: 'mf-users',
                props: true
            }, {
                path: 'acl/users/portfolio/:id',
                component: require("@/views/mutual-funds/acl/user-portfolios.vue").default,
                name: 'mf-user-portfolio',
                props: true
            }, {
                path: 'acl/users/user-returns/:id',
                component: require("@/views/mutual-funds/acl/user-returns.vue").default,
                name: 'user-returns',
                props: true
            }, {
                path: 'variable/mf-variable',
                component: require("@/views/mutual-funds/variable/mf-variable.vue").default,
                name: 'mf-variable',
                props: true
            },{
                path: 'reports/mf-history',
                component: require("@/views/mutual-funds/reports/mf-history.vue").default,
                name: 'mf-history',
                props: true
            }
        ]
    },
    {
        path: '/rawdata',
        name: 'rawdata',
        component: require("@/views/company/rawdata.vue").default
    },
    {
        path: '/overall-rawdata',
        name: 'overallrawdata',
        component: require("@/views/company/rawdata/overallRawData.vue").default
    },
    {
        path: '/derivative-rawdata',
        name: 'derivativerawdata',
        component: require("@/views/company/rawdata/derivatives.vue").default
    },
    {
        path: '/company-prices-graph',
        name: 'companypricegraph',
        component: require("@/views/company/companyPricesGraph.vue").default
    },
    {
        path: '/company-volume-graph',
        name: 'companyvolumegraph',
        component: require("@/views/company/companyVolumeGraph.vue").default
    },
    {
        path: '/company-price-analysis',
        name: 'companypriceanalysis',
        component: require("@/views/company/companyPriceAnalysis.vue").default
    },
    {
        path: '/all-company-price-analysis',
        name: 'allCompanypriceanalysis',
        component: require("@/views/company/allCompanyPriceAnalysis.vue").default
    },
    {
        path: '/growth-analysis',
        name: 'growthanalysis',
        component: require("@/views/company/growthAnalysis.vue").default
    },
    {
        path: '/company/calculateddata/',
        name: 'calculateddata',
        props: true,
        component: require("@/views/company/calculateddata.vue").default
    },
    {
        path: '/company/details/',
        name: 'viewcompany',
        props: true,
        component: require("@/views/company/companyDetails.vue").default
    },
    {
        path: '/industries',
        name: 'sectordata',
        props: true,
        component: require("@/views/industry/industryData.vue").default
    },
    {
        path: '/sector-sales',
        name: 'sector-sales',
        props: true,
        component: require("@/views/industry/sector-sales.vue").default
    },
    {
        path: '/yearwise-percentile-ratios',
        name: 'yearwise-percentile-ratios',
        props: true,
        component: require("@/views/industry/yearwisePercentileRatios.vue").default
    },
    {
        path: '/import',
        name: 'import',
        props: true,
        component: require("@/views/Import.vue").default
    },
    {
        path: '/indices',
        name: 'indices',
        props: true,
        component: require("@/views/indices-data/companywise-indices.vue").default
    },
    {
        path: '/indices-vs-portfolio',
        name: 'indicesvsportfolio',
        props: true,
        component: require("@/views/indices-data/companiesVsPortfolio.vue").default
    },
    {
        path: '/qualitative-statements',
        name: 'qualitativestatements',
        props: true,
        component: require("@/views/qualitative-statements.vue").default
    },
    //Manual forms
    {
        path: '/company-data-forms',
        name: 'companydataforms',
        component: require("@/views/manual-forms/company-data-forms.vue").default
    },
    {
        path: '/p-data-forms',
        name: 'pdataforms',
        component: require("@/views/manual-forms/p-data-forms.vue").default
    },
    //Market Data
    {
        path: '/market-info',
        name: 'market',
        component: require("@/views/market-data/marketInfo.vue").default
    },
    {
        path: '/traling-12-months-sales',
        name: 'trailingSales',
        component: require("@/views/market-data/trailing12MonthsSales.vue").default
    },
    {
        path: '/percentile-ratios',
        name: 'percentileRatios',
        component: require("@/views/market-data/percentileRatios.vue").default
    },
    {
        path: '/market-cap',
        name: 'marketCap',
        component: require("@/views/market-data/marketCap.vue").default
    },
    {
        path: '/insider-transaction',
        name: 'insiderTransaction',
        component: require("@/views/market-data/insiderTransaction.vue").default
    },
    {
        path: '/largest-traded-stock',
        name: 'largestTradedStock',
        component: require("@/views/market-data/largestTradedStock.vue").default
    },
    {
        path: '/relative-strength-ranking',
        name: 'relativeStrengthRanking',
        component: require("@/views/market-data/relativeStrengthRanking.vue").default
    },
    {
        path: '/relative-strength-measure',
        name: 'relativeStrengthMeasure',
        component: require("@/views/market-data/relativeStrengthMeasure.vue").default
    },
    {
        path: '/roe',
        name: 'roe',
        component: require("@/views/market-data/roe.vue").default
    },
    {
        path: '/combined-rank-analysis',
        name: 'CombinedRankAnalysis',
        component: require("@/views/market-data/combined-rank-analysis.vue").default
    },
    {
        path: '/p-analysis',
        name: 'PAnalysis',
        component: require("@/views/market-data/p-analysis.vue").default
    },
    {
        path: '/p-trends',
        name: 'pTrends',
        props: true,
        component: require("@/views/company/pTrends.vue").default
    },
    {
        path: '/p-all',
        name: 'pAll',
        component: require("@/views/market-data/allSumData.vue").default
    },
    {
        path: '/filtered-s1',
        name: 'filteredS1',
        component: require("@/views/market-data/s1-s-filtered.vue").default
    },
    //P Score analysis
    {
        path: '/p-score-analysis',
        name: 'pScoreAnalysis',
        component: require("@/views/market-data/p-score-analysis.vue").default
    },
    {
        path: '/themes',
        name: 'Themes',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
                path: '',
                name: 'themes',
                component: require("@/views/themes/themes.vue").default
            },
            {
                path: 'add',
                name: 'add-theme',
                component: require("@/views/themes/add-theme.vue").default
            },
            {
                path: 'edit/:id',
                component: require("@/views/themes/add-theme.vue").default,
                name: 'edit-theme',
            },
            {
                path: 'blogs',
                name: 'blogs',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [{
                        path: '',
                        name: 'blogs',
                        component: require("@/views/blog/blogs.vue").default
                    },
                    {
                        path: 'add',
                        name: 'add-blog',
                        component: require("@/views/blog/add-blog.vue").default
                    },
                    {
                        path: 'edit/:id',
                        component: require("@/views/blog/add-blog.vue").default,
                        name: 'edit-blog',
                    },
                ]
            },

        ]
    },
    {
        path: '/views/portfolios',
        name: 'Portfolios',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: '/portfolios',
            component: require("@/views/portfolios/listing.vue").default,
            name: 'listing'
        }, {
            path: '/portfolios/details/:id/:name?',
            component: require("@/views/portfolios/portfolio-details.vue").default,
            name: 'portfolio-details',
            props: true
        }, {
            path: '/portfolios/reports/:id/:name?',
            component: require("@/views/portfolios/portfolio-test-reports.vue").default,
            name: 'portfolio-test-reports',
            props: true
        }, {
            path: '/portfolios/edit-stock/:id/:sid',
            component: require("@/views/portfolios/add-stock.vue").default,
            name: 'edit-stock',
            props: true
        }, {
            path: '/portfolios/add',
            component: require("@/views/portfolios/add-portfolios.vue").default,
            name: 'add-portfolio',
            props: true
        }, ]
    },
    {
        path: '/views/acl',
        name: 'users',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
                path: '/acl/add-user',
                component: require("@/views/acl/add-user.vue").default,
                name: 'add-user'
            },
            {
                path: '/acl/edit-user/:id',
                component: require("@/views/acl/add-user.vue").default,
                name: 'edit-user',
            },
            {
                path: '/acl/users',
                name: 'users',
                component: require("@/views/acl/users.vue").default
            },
            {
                path: '/acl/portfolio/:id',
                name: 'user-portfolios',
                component: require("@/views/acl/user-portfolios.vue").default,
            },
           /*  {
                path: '/acl/returns/:id',
                name: 'user-returns',
                component: require("@/views/acl/user-returns.vue").default,
            }, */
            {
                path: '/acl/roles/',
                name: 'roles',
                component: require("@/views/acl/roles/roles.vue").default,
            },
            {
                path: '/acl/roles/edit/:id',
                name: 'edit-roles',
                component: require("@/views/acl/roles/edit.vue").default,
            }
        ]
    },
    {
        path: '/views/activity-logs',
        name: 'Activity Logs',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: '/activity-logs/user-activity',
            name: 'user-activity',
            component: require("@/views/activity-logs/user-activity.vue").default
        }, {
            path: '/activity-logs/download-history',
            name: 'download-history',
            component: require("@/views/activity-logs/download-history.vue").default
        }, {
            path: '/activity-logs/cron-status',
            name: 'cron-status',
            component: require("@/views/activity-logs/cron-status.vue").default
        }, {
            path: '/activity-logs/cron-time-analysis',
            name: 'cron-time-analysis',
            component: require("@/views/activity-logs/cron-time-analysis.vue").default
        }, {
            path: '/activity-logs/data-discrepancy',
            name: 'data-discrepancy',
            component: require("@/views/activity-logs/data-discrepancy.vue").default
        }]
    },

    {
        path: '/views/settings',
        name: 'Frontend Settings',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: '/settings/frontend',
            name: 'frontend-settings',
            component: require("@/views/settings/frontend.vue").default
        }, ]
    },

    {
        path: '/views/reports',
        name: 'Reports',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
                path: '/reports/trending-company',
                component: require("@/views/reports/trending-company.vue").default,
                name: 'trending-company-report'
            },
            {
                path: '/reports/trending-company/user/:id',
                component: require("@/views/reports/trending-company-users.vue").default,
                name: 'trending-company-users'
            },
            {
                path: '/reports/capitaline-apis',
                component: require("@/views/reports/capitaline-apis.vue").default,
                name: 'capitaline-apis'
            },
            {
                path: '/reports/sma-apis',
                component: require("@/views/reports/sma-apis.vue").default,
                name: 'sma-apis'
            },
            {
                path: '/reports/corporate-action',
                component: require("@/views/reports/corporate-action.vue").default,
                name: 'corporate-action'
            },
            {
                path: '/reports/user-feedback',
                component: require("@/views/reports/user-feedback.vue").default,
                name: 'user-feedback'
            },
            {
                path: '/reports/newsletter-subscription',
                component: require("@/views/reports/newsletter-subscription.vue").default,
                name: 'newsletter-subscription'
            },
        ]
    },
    //Metabase
    {
        path: '/metabase/report',
        component: require("@/views/metabase/reports.vue").default,
        name: 'metabaseReport'
    },

    //Redirect to Home
    {
        path: '/redirect-me',
        redirect: {
            name: 'home'
        }
    },
    {
        path: '/do-not-have-access',
        component: require("@/views/Page401.vue").default,
        name: 'unauthorised'
    },
    // 404 redirect to home
    {
        path: '*',
        redirect: {
            name: 'Page404',
            component: Page404
        }
    },


    // UI Components
    {
        path: '/components/buttons',
        name: 'buttons',
        component: Buttons
    },
    {
        path: '/components/badges',
        name: 'badges',
        component: Badges
    },
    {
        path: '/components/socials',
        name: 'socials',
        component: Socials
    },
    {
        path: '/components/cards',
        name: 'cards',
        component: Cards
    },
    {
        path: '/components/modals',
        name: 'modals',
        component: Modals
    },
    {
        path: '/components/alerts',
        name: 'alerts',
        component: Alerts
    },
    {
        path: '/components/progressbars',
        name: 'progressbars',
        component: ProgressBars
    },
    //{ path : '/components/switches', name: 'switches', component: Switches },
    {
        path: '/components/tabs',
        name: 'tabs',
        component: Tabs
    },
    {
        path: '/components/basic-form',
        name: 'basic-form',
        component: BasicForms
    },
    {
        path: '/components/advanced-form',
        name: 'advanced-form',
        component: AdvancedForms
    },
    {
        path: '/components/wizard-form',
        name: 'wizard-form',
        component: FormWizard
    },
    {
        path: '/components/grids',
        name: 'grids',
        component: Grids
    },
    {
        path: '/components/widgets',
        name: 'widgets',
        component: Widgets
    },
    {
        path: '/components/typography',
        name: 'typography',
        component: Typography
    },
    {
        path: '/components/tables',
        name: 'tables',
        component: Tables
    },
    {
        path: '/components/icons',
        component: Icons,
        children: [{
                path: '',
                component: SetsList,
                name: 'Icons'
            },
            {
                path: ':name',
                component: Sets,
                props: true,

            }
        ]
    },
    {
        path: '/components/charts',
        name: 'Charts',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [

            {
                path: '/components/chartjs',
                component: ChartJS,
                name: 'chart-js'
            },
            {
                path: '/components/flotchart',
                component: FlotChart,
                name: 'flotchart'
            },

            {
                path: '/components/peitychart',
                component: PeityChart,
                name: 'peitychart'
            },

        ]
    },
    {
        path: '/components/maps',
        name: 'Maps',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
                path: '/components/maps/google-maps',
                component: GoogleMapsPage,
                name: 'google-maps-page'
            },
            {
                path: '/components/maps/leaflet-maps',
                component: LeafletMapsPage,
                name: 'leaflet-maps-page'
            },
            {
                path: '/components/maps/bubble-maps',
                component: BubbleMapsPage,
                name: 'bubble-maps-page'
            },
            {
                path: '/components/maps/line-maps',
                component: LineMapsPage,
                name: 'line-maps-page'
            },

        ]
    },
];


// WEBPACK FOOTER //
// ./src/router/routes.js